import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import TabNavigation from "../../../components/TabNavigation/TabNavigation";
import CatalogContent from "../components/CatalogContent";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useTabState } from "../hooks/tabState";
import { useTranslation } from "react-i18next";
import { withTranslations } from "../../../hoc/withTranslations/withTranslations";
import { useAppSelector } from "../../../hooks/useAppDispatch"; // import the hook
import { RootState } from "../../../redux/store"; // import RootState

const LOCALE = "modules_MyGiftTable_pages_Products";

const Products: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [, setLastCategory] = useTabState("lastCategory", t("catalog"));

  // Read stickyOffset from Redux
  const stickyOffset = useAppSelector(
    (state: RootState) => state.uiState.stickyOffset
  );

  // Get category values from URL query
  const category = searchParams.get("category") || null;
  const categoryID = searchParams.get("category_id") || null;

  useEffect(() => {
    if (category) {
      setLastCategory(category);
    } else {
      setLastCategory(t("catalog"));
    }
  }, [category, setLastCategory, t]);

  return (
    <MainLayout
      content={
        <TabNavigation
          stickyOffset={stickyOffset} // pass Redux value here
          disableActiveTab={false}
          tabs={[
            {
              label: (
                <div
                  className="flex items-center justify-center space-x-2 cursor-pointer"
                  onClick={() => navigate("/my-table")}
                >
                  <FaArrowLeftLong className="text-gray-500 hover:text-gray-700" />
                  <span className="text-center">
                    {category || t("catalog")}
                  </span>
                </div>
              ),
              component: (
                <CatalogContent categoryID={categoryID || undefined} />
              ),
              isActive: true,
            },
            {
              label: t("myProducts"),
              onClick: () => navigate("/my-table/my-products"),
              component: null,
              isActive: false,
            },
          ]}
        />
      }
    />
  );
};

export default withTranslations(LOCALE)(Products);
